import styled from 'styled-components'
import SuperSlideyBar from 'src/components/SideMenu/SuperSlideyBar'

export const ElevatedDrawer = styled(SuperSlideyBar)`
	box-shadow: -3px 0 7px -1px rgb(0 0 0 / 10%);
`
